/**
 * Better Auth Client Configuration
 *
 * Client instance and hooks for client components
 */

import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

/**
 * Better Auth client instance
 */
export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

// Export client methods for convenience
export const {
  signIn,
  signUp,
  signOut,
  requestPasswordReset,
  useSession,
  getSession,
} = authClient;
